import { render, staticRenderFns } from "./last_commit.vue.js?vue&type=template&id=03b78546&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./last_commit.vue?vue&type=template&id=03b78546&vue3"
import script from "./last_commit.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./last_commit.vue?vue&type=script&lang=js&vue3"
export * from "./last_commit.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./last_commit.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports